import { cardBadge } from '@squareup/dex-ui-shared-markdown-card';
import React, { FC, PropsWithChildren } from 'react';

interface MdxCardBadgeProps {
  href?: string;
}

const CardBadgeComponent = cardBadge.component.value as FC<
  PropsWithChildren<MdxCardBadgeProps>
>;

const MdxCardBadge: FC<PropsWithChildren<MdxCardBadgeProps>> = ({
  children,
  href,
}) => {
  return (
    <CardBadgeComponent {...(href ? { href } : {})}>
      {children}
    </CardBadgeComponent>
  );
};

MdxCardBadge.displayName = 'MdxCardBadge';

export { MdxCardBadge };
